import { createEnv } from "@t3-oss/env-core";
import { z } from "zod";

const importMetaEnv = (import.meta as unknown as { env?: NodeJS.ProcessEnv }).env ?? {};
const nodeProcessEnv = typeof process !== "undefined" ? process.env : undefined;
const runtimeEnv = { ...nodeProcessEnv, ...importMetaEnv };

export const env = createEnv({
  skipValidation:
    importMetaEnv.SKIP_ENV_VALIDATION === "1" || nodeProcessEnv?.SKIP_ENV_VALIDATION === "1",
  clientPrefix: "VITE_",
  client: {
    VITE_EMAIL_EDITOR_AMP_ENABLED: z.enum(["true", "false"]).default("false"),
    VITE_GIT_COMMIT: z.string().optional().default("dev"),
    VITE_SERVERSIDE_HOST: z.string(),
    VITE_CLIENTSIDE_HOST: z.url().default("http://localhost:5173"),
    VITE_POSTHOG_KEY: z.string().optional(),
    VITE_POSTHOG_HOST: z.string().optional(),
    VITE_STAGE: z
      .enum(["local", "dev", "prod"])
      .or(z.string().regex(/^preview-\d+$/))
      .default("local") as z.ZodType<"local" | "dev" | "prod" | `preview-${number}`>,
    VITE_NODE_ENV: z.enum(["development", "production"]).default("development"),
    VITE_SENTRY_DSN: z.url().optional(),
    VITE_CDN_PATH: z.url().default("http://localhost:8787/cdn"),
  },
  runtimeEnv,
});
